<div class="flex h-full min-h-0 flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-chatbot-multi
        [analyticsBadgeLoading]="analyticsStatusBadgeLoading()"
        [analyticsKeywordCounts]="getKeywordCount"
        [form]="deliverableForm()"
        [creatorId]="executionAnalytics()?.creatorId"
        [analyticsKeywordJump]="jumpToNextKeywordFinding"
        [analyticsKeywordJumpTargets]="keywordTableRowIds()"
        [analyticsKeywordJumpTargetsReady]="keywordTableRowIdsReady()"
        [isCustomMode]="true"
        [creators]="[]"
        [isViewMode]="true"
        [isExpanded]="true"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        [statusMinInterval]="currentDeliverable()?.statusMinInterval"
        [statusMaxInterval]="currentDeliverable()?.statusMaxInterval"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible) {
    <div class="flex flex-col gap-3">
      <h3 class="text-sm font-bold">
        {{ 'pages.campaignDetails.ctaAnalytics.details.detected' | translate }}
        {{ 'pages.campaignDetails.ctaAnalytics.deliverable.' + deliverableType + '.title' | translate | lowercase }}
      </h3>

      <app-line-graph
        class="p-3 bg-shikenso-gray-base-24 rounded-2xl"
        [dotGraphData]="dotGraphData()"
        [viewerGraphData]="viewerGraphData()!"
        (pointSelected)="onDataPointClick($event)"
      />
    </div>

    <app-analytics-details-table
      matSort
      [dataSource]="dataSource"
      [dataCount]="dataCount()"
      [displayedColumns]="displayedColumns"
      [sort]="sort()"
      [selectedRowId]="selectedDataId()"
    >
      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.campaignDetails.ctaAnalytics.details.chatBotMulti.time' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.timestamp | date: displayTimeFormat }}</td>
      </ng-container>

      <ng-container matColumnDef="videoTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.campaignDetails.ctaAnalytics.details.chatBotMulti.videoTime' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.videoTimeLabel }}</td>
      </ng-container>

      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.campaignDetails.ctaAnalytics.details.chatBotMulti.user' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            matTooltip
            matTooltipPosition="above"
            class="max-w-[108px] line-clamp-1 text-ellipsis"
            [appTextClampTooltip]="element.user"
          >
            {{ element.user }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.campaignDetails.ctaAnalytics.details.chatBotMulti.message' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="text-sm">
          <div class="flex gap-2 items-center">
            <app-icon-badge
              class="max-[1440px]:hidden"
              content="icons/chat.svg"
              backgroundColor="transparent"
              [size]="16"
              [iconSize]="16"
            />
            <div [innerHTML]="highlightKeywords(element.text, element.foundKeywords)"></div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="flex items-center justify-end gap-1">
            <button
              mat-icon-button
              class="mat-secondary-gray-border-button-color"
              (click)="onRowClick($event, element)"
            >
              <app-icon src="/icons/arrow-up-right.svg" alt="View" [size]="12" />
            </button>
            @if (manualFindingStatusStore) {
              @if (hasRowPendingDeletions(element)) {
                @if (isVisualizerActing(element.id)) {
                  <app-dots-spinner />
                } @else {
                  <button
                    mat-icon-button
                    class="mat-secondary-gray-border-button-color"
                    (click)="onRevertRow(element); $event.stopPropagation()"
                  >
                    <app-icon src="/icons/redo.svg" alt="Revert" [size]="16" />
                  </button>
                }
              }

              @if (canDelete() && !hasRowPendingDeletions(element)) {
                @if (isFindingInFlight(element.id)) {
                  <app-dots-spinner />
                } @else {
                  <button
                    mat-icon-button
                    class="mat-secondary-gray-border-button-color"
                    (click)="onDeleteSingleRowFinding(element); $event.stopPropagation()"
                  >
                    <app-icon src="/icons/trash.svg" alt="Delete" [size]="16" />
                  </button>
                }
              }
            }
          </div>
        </td>
      </ng-container>
    </app-analytics-details-table>

    @if (shouldRenderEmbeddedPlayer()) {
      <div class="w-full mt-4">
        <app-embedded-video-player
          [videoUrl]="streamUrl()"
          [platform]="platform()!"
          [autoPlay]="false"
          [seekToTime]="seekTime()"
        />
      </div>
    }
  }
</div>
